//
//
//
//
//
//
//
//
//
//
//
//

import globalMixin from "@/lib/global";
import vuexMixin from "@/lib/vuexMixin";

export default {
  name: "layoutOutside",
  mixins: [globalMixin, vuexMixin],
  methods: {
    goTo(path) {
      this.$router.push(path);
    },
  },
  computed: {
    backgroundStyle() {
      return {
        backgroundImage: `url(${this.imageLoginVx})`,
        backgroundColor: this.primaryVx,
        height: '100%',
        backgroundSize: 'cover',
        backgroundPosition: 'center'
      };
    }
  },
  head() {
    return {
      style: [
        {
          cssText: `
            :root {
              --primary: ${this.primaryVx};
            }
          `,
          type: "text/css",
        },
      ],
    };
  },
};
